module.exports = __webpack_public_path__ + "img/banner_7.0777f05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/banner_7.jpg
// module id = 43Ur
// module chunks = 0